import { Typography, Button, Row, Col, Image } from "antd";
import WheelImage from "../../assets/images/wheel.webp";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

const { Title, Paragraph } = Typography;

const HomePageSecuritySection = () => {
  const { t } = useTranslation();
  const btnArr = [
    { key: "to-start-up", href: "/auth/intro" },
    { key: "security-contact-text", href: "/contact" },
  ];

  return (
    <div>
      <Row className="contact_main" justify="center">
        <Row className="contact-container">
          <Col className="content-col">
            <div className="main-title">{t("smart-safe-security-text")}</div>
            <Paragraph className="text-row">
              <Paragraph className="Contact_description">{t("Secure-payments-verified-creators-text")}</Paragraph>
              <Paragraph className="Contact_description">{t("our-high-quality-protection-systems")}</Paragraph>
              <Paragraph className="Contact_description">{t("security-seriously-text")}</Paragraph>
            </Paragraph>
            <Row className="button-row">
              {btnArr.map((item, index) => (
                <Col key={index}>
                  <Link to={item?.href}>
                    {" "}
                    <Button className={`custom-button ${index === 0 ? "primary-button" : "secondary-button"}`} block>
                      {t(item.key)}
                    </Button>
                  </Link>
                </Col>
              ))}
            </Row>
          </Col>
          <Col className="image-col">
            <Image src={WheelImage} alt="img not available" className="wheel-image" preview={false} />
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default HomePageSecuritySection;
